import React, { useContext } from "react";

// styles
import styles from "./styles.module.css";

//icons
import { BiSolidMoviePlay } from "react-icons/bi";
import { GoChevronDown } from "react-icons/go";
import { HiPlay } from "react-icons/hi";
import { MdPlaylistAdd } from "react-icons/md";

// router
import { useNavigate } from "react-router-dom";

// motion
import { AnimatePresence, motion } from "motion/react";

// utils
import { uri, useGetVideoDuration } from "../../../utils/video";
import { AuthContext } from "../../../context";

interface VideoItem {
  videos: any[];
  title: string;
  _id: string;
}

type Props = {
  item: VideoItem;
  accordionId: string;
  index: number;
  courseId: string;
  openModal?: (item: any) => void;
};

const VideoAccordion = ({
  item,
  accordionId,
  index,
  courseId,
  openModal,
}: Props) => {
  const { user } = useContext(AuthContext);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const { totalDuration } = useGetVideoDuration(item as any);

  return (
    <div id={accordionId} title={item?.title} className={styles.accordion}>
      <div className={styles.titleContainer}>
        <h4>
          {index + 1}. {item?.title}
        </h4>
        <div
          className={`${styles.icon} ${open ? styles.open : undefined}`}
          onClick={() => setOpen((prev) => !prev)}
        >
          <GoChevronDown />
        </div>
      </div>
      <div className={styles.duration}>
        <BiSolidMoviePlay color="#17a8ab" size={20} />
        <span>
          {item?.videos?.length} video | {totalDuration}
        </span>
      </div>
      <AnimatePresence>
        {open ? (
          <motion.div
            className={styles.singleVideoWrapper}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "fit-content", opacity: 1 }}
            exit={{ height: 0 }}
          >
            <div className={styles.line} />
            {item.videos.map((video, idx) => (
              <div
                key={idx}
                className={styles.singleVideo}
                onClick={() =>
                  navigate(
                    `/app/courses/watch/${courseId}/${item?._id}/${video?._id}`
                  )
                }
              >
                <HiPlay color="#17a8ab" size={18} />
                <div className={styles.details}>
                  <p>{video?.title}</p>
                  <div className={styles.duration2}>
                    <BiSolidMoviePlay color="#17a8ab" size={16} />
                    <span>duration</span>
                  </div>
                </div>
              </div>
            ))}
            {user?.role === "Admin" && openModal && (
              <button className={styles.addBtn} onClick={() => openModal(item)}>
                <MdPlaylistAdd size={20} />
              </button>
            )}
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

export default VideoAccordion;
